import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { CarouselComponent } from '../../components/carousel/carousel'

const CAROUSEL_SELECTOR = `[data-product-media-carousel-component]`

export class ProductMediaCarousel extends BaseComponent {
  mountComponent(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(variant, jump = false): void {
    const carousel: CarouselComponent = $el(CAROUSEL_SELECTOR, this)

    if (variant && variant.featured_media && carousel) {
      const slides = carousel.embla.slideNodes()
      const slideIndex = slides.findIndex(slide => {
        if (!slide.dataset.mediaId) {
          return false
        }
        return +slide.dataset.mediaId === +variant.featured_media.id
      })

      carousel.embla.scrollTo(slideIndex, jump)
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}
